import { units } from '@ui/css';
import { combineTokens } from '@utils/css';
import { makeSizeTokens } from '@utils/react/selectors';

const size = makeSizeTokens("--drawer--size", {
  height: units.px(200),
  width: "100%"
});
const tokens = combineTokens("--drawer", {
  amountOfColumns: 5,
  amountOfRows: 1,
  stickyOffset: units.px(200)
});
const wrapper = "_35swgyhg2z";
const drawer = "_35sdd2nk4f";
const label = "_35sl1nmodjs";

export { drawer, label, size, tokens, wrapper };
import "./_drawer.style.linaria.module.css";
//# sourceMappingURL=_drawer.style.js.map
